import React from "react";

/**
 * Shared "this works best on a bigger screen" gate for the handful of
 * advisor tools that are genuinely desktop workbenches — a drag-drop
 * document composer, a multi-pane portfolio builder, a bookkeeping ledger.
 * Squeezing those into a phone width doesn't produce a usable mobile
 * screen, it produces a broken desktop one. Rather than build (and
 * maintain) a real mobile layout for tools whose core interaction is
 * authoring/arranging, we show this instead and point back to something
 * that works on a phone.
 *
 * `onBack`, when given, is used for the return action; otherwise falls
 * back to browser history (the standalone editor routes have no advisor
 * tab state to hand back into).
 */
export default function DesktopOnlyGate({
  title,
  onBack,
}: {
  title: string;
  onBack?: () => void;
}) {
  return (
    <div style={{ minHeight: "60vh", display: "flex", alignItems: "center", justifyContent: "center", padding: "32px 24px" }}>
      <div style={{ maxWidth: "320px", textAlign: "center" }}>
        <p style={{ fontSize: "34px", margin: "0 0 12px" }}>💻</p>
        <h2 style={{ margin: "0 0 8px", fontSize: "16px", fontWeight: 800, color: "#111827" }}>{title} works best on a larger screen</h2>
        <p style={{ margin: "0 0 20px", fontSize: "13px", color: "#6B7280", lineHeight: 1.55 }}>
          This tool needs more room to work than a phone can give it. Pick it back up from a laptop or desktop.
        </p>
        <button
          onClick={() => (onBack ? onBack() : window.history.back())}
          style={{ padding: "9px 18px", background: "var(--brand-primary)", color: "white", border: "none", borderRadius: "4px", fontSize: "13px", fontWeight: 700, cursor: "pointer", fontFamily: "inherit" }}
        >
          ← Back
        </button>
      </div>
    </div>
  );
}
